module.exports = __webpack_public_path__ + "img/icon_mail.9f850dd.svg";